import { render, staticRenderFns } from "./AgeTechService.vue?vue&type=template&id=44c82302&scoped=true"
import script from "./AgeTechService.vue?vue&type=script&lang=js"
export * from "./AgeTechService.vue?vue&type=script&lang=js"
import style0 from "./AgeTechService.vue?vue&type=style&index=0&id=44c82302&prod&lang=css"
import style1 from "./AgeTechService.vue?vue&type=style&index=1&id=44c82302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c82302",
  null
  
)

export default component.exports